/* ATMA HOME — interacciones del mockup (progressive enhancement) */
document.addEventListener('DOMContentLoaded', () => {

  /* --- Menú móvil --- */
  const navToggle = document.querySelector('.nav-toggle');
  const mainNav = document.querySelector('.main-nav');
  if (navToggle && mainNav) {
    navToggle.addEventListener('click', () => {
      const isOpen = mainNav.classList.toggle('is-open');
      navToggle.setAttribute('aria-expanded', String(isOpen));
    });
  }

  /* Submenús en móvil: click abre/cierra el mega-menu (además del hover en desktop) */
  document.querySelectorAll('.nav-list > li').forEach((li) => {
    const link = li.querySelector('.nav-link');
    const mega = li.querySelector('.mega');
    if (!link || !mega) return;
    link.addEventListener('click', (e) => {
      if (window.matchMedia('(max-width: 780px)').matches) {
        e.preventDefault();
        const isOpen = li.classList.toggle('is-open');
        link.setAttribute('aria-expanded', String(isOpen));
      }
    });
  });

  /* --- Hero carousel simple --- */
  const hero = document.querySelector('[data-hero]');
  if (hero) {
    const slides = hero.querySelectorAll('[data-slide]');
    const dotsWrap = hero.querySelector('.hero-dots');
    let current = 0;
    let timer;

    const show = (i) => {
      slides.forEach((s, idx) => s.style.display = idx === i ? 'flex' : 'none');
      if (dotsWrap) {
        dotsWrap.querySelectorAll('button').forEach((b, idx) => {
          b.setAttribute('aria-current', String(idx === i));
        });
      }
      current = i;
    };

    if (dotsWrap) {
      slides.forEach((_, idx) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', `Ir a la promoción ${idx + 1}`);
        b.addEventListener('click', () => { show(idx); resetTimer(); });
        dotsWrap.appendChild(b);
      });
    }

    function resetTimer() {
      clearInterval(timer);
      timer = setInterval(() => show((current + 1) % slides.length), 6000);
    }

    if (slides.length > 1) {
      show(0);
      resetTimer();
      hero.addEventListener('mouseenter', () => clearInterval(timer));
      hero.addEventListener('mouseleave', resetTimer);
    }
  }

  /* --- Newsletter --- */
  document.querySelectorAll('[data-newsletter-form]').forEach((form) => {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const input = form.querySelector('input[type="email"]');
      const success = form.parentElement.querySelector('.newsletter-success');
      if (input && input.checkValidity()) {
        form.hidden = true;
        if (success) {
          success.classList.add('is-visible');
          success.setAttribute('role', 'status');
          success.focus?.();
        }
      } else {
        input?.reportValidity();
      }
    });
  });

  /* --- Tabs producto --- */
  document.querySelectorAll('.tabs').forEach((tabsRoot) => {
    const tabs = tabsRoot.querySelectorAll('[role="tab"]');
    const panels = tabsRoot.querySelectorAll('[role="tabpanel"]');
    tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => {
        tabs.forEach((t) => t.setAttribute('aria-selected', 'false'));
        panels.forEach((p) => p.hidden = true);
        tab.setAttribute('aria-selected', 'true');
        panels[i].hidden = false;
      });
      tab.addEventListener('keydown', (e) => {
        let idx = null;
        if (e.key === 'ArrowRight') idx = (i + 1) % tabs.length;
        if (e.key === 'ArrowLeft') idx = (i - 1 + tabs.length) % tabs.length;
        if (idx !== null) { tabs[idx].focus(); tabs[idx].click(); }
      });
    });
  });

  /* --- Selector de cantidad --- */
  document.querySelectorAll('[data-qty]').forEach((wrap) => {
    const input = wrap.querySelector('input');
    wrap.querySelectorAll('button').forEach((btn) => {
      btn.addEventListener('click', () => {
        let val = parseInt(input.value, 10) || 1;
        val += btn.dataset.step === 'down' ? -1 : 1;
        input.value = Math.max(1, val);
        input.dispatchEvent(new Event('change'));
      });
    });
  });

  /* --- Cupón (simulado) --- */
  const couponForm = document.querySelector('[data-coupon-form]');
  if (couponForm) {
    couponForm.addEventListener('submit', (e) => {
      e.preventDefault();
      const msg = couponForm.parentElement.querySelector('[data-coupon-msg]');
      const val = couponForm.querySelector('input').value.trim().toUpperCase();
      if (msg) {
        msg.hidden = false;
        msg.textContent = val === 'ATMA10'
          ? '¡Cupón ATMA10 aplicado! 10% de descuento adicional.'
          : 'Cupón no válido o expirado. Prueba con ATMA10.';
        msg.style.color = val === 'ATMA10' ? 'var(--clr-success)' : 'var(--clr-danger)';
      }
    });
  }

  /* --- Validación accesible de checkout --- */
  const checkoutForm = document.querySelector('[data-checkout-form]');
  if (checkoutForm) {
    checkoutForm.addEventListener('submit', (e) => {
      let valid = true;
      checkoutForm.querySelectorAll('[required]').forEach((field) => {
        const wrap = field.closest('.field');
        if (!field.checkValidity()) {
          valid = false;
          wrap?.classList.add('has-error');
        } else {
          wrap?.classList.remove('has-error');
        }
      });
      if (!valid) {
        e.preventDefault();
        checkoutForm.querySelector('.has-error input, .has-error select')?.focus();
      }
    });
  }

  /* --- Zona privada: mostrar/ocultar contraseña --- */
  document.querySelectorAll('[data-toggle-pass]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const input = document.querySelector(btn.dataset.togglePass);
      if (!input) return;
      const isPass = input.type === 'password';
      input.type = isPass ? 'text' : 'password';
      btn.setAttribute('aria-pressed', String(isPass));
      btn.textContent = isPass ? 'Ocultar' : 'Mostrar';
    });
  });

  /* --- Producto: miniaturas de galería --- */
  const mainImage = document.getElementById('main-image');
  document.querySelectorAll('.js-thumb').forEach((thumb) => {
    thumb.addEventListener('click', () => {
      if (mainImage && thumb.dataset.full) mainImage.src = thumb.dataset.full;
      document.querySelectorAll('.js-thumb').forEach((t) => t.style.borderColor = 'var(--clr-line-strong)');
      thumb.style.borderColor = 'var(--clr-terracotta)';
    });
  });

  /* --- Producto: selector de variantes (opciones -> <select name="id">) --- */
  const variantSelect = document.querySelector('.js-variant-select');
  const optionInputs = document.querySelectorAll('.js-option-selector');
  if (variantSelect && optionInputs.length) {
    const optionGroups = {};
    optionInputs.forEach((input) => {
      optionGroups[input.name] = optionGroups[input.name] || [];
      optionGroups[input.name].push(input);
    });
    const updateVariant = () => {
      const selected = Object.keys(optionGroups).map((name) => {
        const checked = optionGroups[name].find((i) => i.checked);
        return checked ? checked.value : null;
      });
      const options = Array.from(variantSelect.options);
      const match = options.find((opt) => {
        const parts = opt.textContent.trim().split(' / ');
        return selected.every((val, i) => !val || parts[i] === val);
      });
      if (match) variantSelect.value = match.value;
    };
    optionInputs.forEach((input) => input.addEventListener('change', updateVariant));
  }
});
